import Vue from 'vue'
import Router from 'vue-router'

//组件模块
import index from './components/index'
import proList1 from './components/proList1'
import proList2 from './components/proList2'
import proList3 from './components/proList3'
import donation from './components/donation'
import introduce from './components/introduce'
import pic from './components/pic'

Vue.use(Router)
export default new Router({
  mode: 'history',
  //base:'haihunhou',
  routes: [
    { path: '/', name: 'index', component: index ,meta: {title: '百川汇海'}},
    { path: '/introduce', name: 'introduce', component: introduce ,meta: {title: '百川汇海-前言'} },
    { path: '/proList1', name: 'proList1', component: proList1 ,meta: {title: '百川汇海-第一单元'} },
    { path: '/proList2', name: 'proList2', component: proList2 ,meta: {title: '百川汇海-第二单元'} },
    { path: '/proList3', name: 'proList3', component: proList3 ,meta: {title: '百川汇海-第三单元'} },
    { path: '/donation', name: 'donation', component: donation ,meta: {title: '百川汇海-捐赠作品'}},
    { path: '/pic', name: 'pic', component: pic ,meta: {title: '百川汇海'}},
  ],
  scrollBehavior (to, from, savedPosition) {
       if (savedPosition) {
        return savedPosition
       } else {
        return { x: 0, y: 0 }
       }
   }
})
var reg = new RegExp("code=([^&]+)");